<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Lista de PDVs' | translate}}
    </div>
</div>

<main class="container">
    <h1 i18n>{{ 'Lista de PDVs' | translate}}</h1>

    <div class="filtros">
        <div class="filtro">
            <label for="status" i18n>{{ 'País' | translate}}</label>
            <select id="status" [(ngModel)]="filtro.pais">
                <option value="" i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let status of jsonPaises" [value]="status.id">{{status.name}}</option>
            </select>
        </div>
        <div class="filtro">
            <label for="cidade" i18n>{{ 'Cidade' | translate}}</label>
            <input type="text" id="cidade" [(ngModel)]="filtro.cidade">
        </div>
        <div class="filtro">
            <label for="codPdv" i18n>{{ 'Código PDV' | translate}}</label>
            <input type="text" id="codPdv" [(ngModel)]="filtro.codPdv">
        </div>
        <div class="filtro">
            <label for="search" i18n>{{ 'Pesquisar por nome ou código' | translate}}</label>
            <input type="text" id="search" [(ngModel)]="filtro.search">
        </div>
        <div class="filtro">
            <label for="pdvStatus" i18n>{{ 'Status' | translate}}</label>
            <select id="pdvStatus" [(ngModel)]="filtro.status">
                <option value="ativos" i18n>{{ 'Ativos' | translate}}</option>
                <option value="inativos" i18n>{{ 'Inativos' | translate}}</option>
                <option value="todos" i18n>{{ 'Todos' | translate}}</option>
            </select>
        </div>
        <div class="filtro">
            <label>&nbsp;</label>
            <button (click)="consultar()" class="red_button" i18n>{{ 'Consultar' | translate}}</button>
        </div>
        <div class="filtro">
            <label i18n>{{ 'Limpar filtros' | translate}}</label>
            <button (click)="limparFiltro()" class="red_button" i18n>{{ 'Limpar' | translate}}</button>
        </div>
    </div>

    <div class="add_group_button">
        <button (click)="openUploadModal()" class="red_button" i18n>{{ 'Upload de PDVs' | translate}}</button>
        <button (click)="adicionarPdv()" class="red_button" i18n>{{ 'Adicionar PDV' | translate}}</button>
    </div>

    <table border="0" cellpadding="0" cellspacing="0">
    <thead>
        <tr>
            <th i18n>#</th>
            <th i18n>{{ 'País' | translate}}</th>
            <th i18n>{{ 'Código da Cidade' | translate}}</th>
            <th i18n>{{ 'Nome da Cidade' | translate}}</th>
            <th i18n>{{ 'Código da Farmácia' | translate}}</th>
            <th i18n>{{ 'Nome do PDV' | translate}}</th>
            <th i18n>{{ 'Status' | translate}}</th>
            <th i18n>{{ 'Ações' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor='let item of listaShowItens | paginate: { itemsPerPage: 15, currentPage: currentPage }; let i = index' [class.inactive-row]="item.isActive === false">
            <td>
                {{ (currentPage - 1) * 15 + i + 1 }}
            </td>
            <td>
                {{getCountry(item.countryId)}}
            </td>
            <td>
                {{item.cdgCiudad}}
            </td>
            <td>
                {{item.ciudad}}
            </td>
            <td>
                {{item.cdg_farmac}}
            </td>
            <td>
                {{item.name}}
            </td>
            <td>
                {{ (item.isActive === false ? 'Inativo' : 'Ativo') | translate }}
            </td>
            <td>
                <a (click)="editarPdv(item)" class="light_button" title="{{ 'Ver detalhes' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/><path d="M14 3v5h5M16 13H8M16 17H8M10 9H8"/></svg>
                </a>

                <a (click)="removerPdv(item)" class="dark_button" title="{{ 'Remover' | translate}}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </a>
            </td>
        </tr>
    </tbody>
    </table>

    <div class="text-center pagination">
        <div class="pagination-info">
            {{ 'Total de registros' | translate }}: {{ listaShowItens.length }}
        </div>
        <div class="pagination-controls">
            <pagination-controls (pageChange)="currentPage = $event" previousLabel="" nextLabel=""></pagination-controls>
        </div>
    </div>
</main>

<!-- Modal: Upload de PDVs por país -->
<div class="modal" tabindex="-1" role="dialog" *ngIf="isUploadModalOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Upload de PDVs' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeUploadModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group filtro">
          <label for="uploadPais" i18n>{{ 'País' | translate }}:</label>
          <select id="uploadPais" [(ngModel)]="uploadCountryId">
            <option value="" i18n>{{ 'Selecione um país' | translate }}</option>
            <option *ngFor="let pais of jsonPaises" [value]="pais.id">{{ pais.name }}</option>
          </select>
        </div>

        <div class="upload-pdv-aviso">
          <p i18n>{{ 'O arquivo deve seguir o layout.' | translate }}</p>
          <p i18n>{{ 'A carga deve ser sempre completa, as fármacias ausentes no arquivo serão desabilitadas.' | translate }}</p>
        </div>

        <div class="form-group filtro">
          <label i18n for="pdvFile">{{ 'Arquivo de PDVs' | translate }}:</label>
          <input type="file" id="pdvFile" class="form-control pdv-file-input" (change)="onPdvFileSelected($event)">
          <small *ngIf="selectedPdvFileCount !== null">
            {{ 'Quantidade de PDVs no arquivo: {{count}}' | translate: { count: selectedPdvFileCount } }}
          </small>
        </div>

        <div class="form-group filtro">
          <button type="button" class="red_button padding" (click)="downloadPdvTemplate()" title="{{ 'Download do layout CSV para upload de PDVs' | translate }}">
            {{ 'Download Layout' | translate }}
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <button class="red_button padding" (click)="uploadPdv()" type="button" [disabled]="uploadingPdv" i18n>
          {{ 'Upload' | translate }}
        </button>
        <button class="red_button padding" (click)="closeUploadModal()">{{ 'Fechar' | translate }}</button>
      </div>
    </div>
  </div>
</div>
